import sectionCustomizeCardCss from '../css-snippets/section-customize-card';

const html = `
<style>${sectionCustomizeCardCss}</style>
<div data-attribute="card-container" data-background="#EBE6E2" style="background-color: #EBE6E2;"
  data-top-padding="true" data-bottom-padding="true">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="wrap-card container">
      <div data-attribute="card-item-content" data-order="1" class="card-left" data-style-center-y="false"
        style="order: 1;">
        <div data-attribute="card-rated-row" data-show-rating="true" style="display: block;">
          <div class="wrap-rated">
            <div data-attribute="rating-stars" data-value="4" class="wrap-stars">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
            </div>
            <div data-attribute="rating-text" class="wrap-rating">Rated 4/5 by 12,000+ happy pet owners</div>
          </div>
        </div>
        <div data-attribute="card-content" class="card-content">
          <div data-attribute="card-title">
            <h2>Say goodbye to messy seats and anxious rides.</h2>
          </div>
          <div data-attribute="card-description">
            <p>Regular seat covers sag, slide, and tear. The bold Waterproof Dog Car Seat Cover with Hard Bottom offers
              a sturdy, no-sag design that keeps pets safe and comfortable on every trip.</p>
            <p>&nbsp;</p>
            <p>Built with 4-layer waterproof protection, it shields your car from fur, dirt, and spills. The mesh window
              eases anxiety, while the 3-in-1 design converts easily between hammock, bench, or cargo liner.</p>
            <p>&nbsp;</p>
            <p>Perfect for pet parents who want a clean car, calm dog, and stress-free travel.</p>
          </div>
        </div>
        <div data-attribute="card-btn-row" data-show-btn="true" class="row-btn" style="display: block;">
          <a data-attribute="card-btn" class="card-btn" href="#">👉 Buy Now</a>
          <div data-attribute="sub-btn" class="sub-btn">Free Shipping &amp; 30 Day Guarantee!</div>
        </div>
      </div>
      <div data-attribute="card-item-image" data-order="2" class="card-right" style="order: 2;">
        <div class="wrap-img">
          <img loading="lazy" data-attribute="card-image" class="card-image"
            src="https://prod.cdnstream.cloud/images/0196dd92-dd30-75f0-9375-994457c907e8/2025/05/31/01972659-7479-7e53-8622-cfe3c9c5d100-IMAGE%20RATING-IMAGE-BODY-A%20.gif"
            alt="">
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
